module.exports = __webpack_public_path__ + "static/media/font_regular.19ab5505.woff";